import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type DownloadBlobLinkMutationVariables = {
  uri: Types.Scalars['String'],
  linkType?: Types.Maybe<Types.LinkType>,
  expiresIn?: Types.Maybe<Types.Scalars['Int']>
};


export type DownloadBlobLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'downloadBlobLink'>
);

export const DownloadBlobLinkDocument = gql`
    mutation DownloadBlobLink($uri: String!, $linkType: LinkType, $expiresIn: Int) {
  downloadBlobLink(uri: $uri, linkType: $linkType, expiresIn: $expiresIn)
}
    `;
export type DownloadBlobLinkMutationFn = ApolloReactCommon.MutationFunction<DownloadBlobLinkMutation, DownloadBlobLinkMutationVariables>;

    export function useDownloadBlobLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadBlobLinkMutation, DownloadBlobLinkMutationVariables>) {
      return ApolloReactHooks.useMutation<DownloadBlobLinkMutation, DownloadBlobLinkMutationVariables>(DownloadBlobLinkDocument, baseOptions);
    };
export type DownloadBlobLinkMutationHookResult = ReturnType<typeof useDownloadBlobLinkMutation>;
export type DownloadBlobLinkMutationResult = ApolloReactCommon.MutationResult<DownloadBlobLinkMutation>;
export type DownloadBlobLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<DownloadBlobLinkMutation, DownloadBlobLinkMutationVariables>;